import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
// Assets
import ServiceLogoWhite from "../../assets/svg/Services/ServiceLogo_white";

export default function Contact() {
  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  return (
    <Wrapper>
      <div className="darkBg">
        <div className="container">
          <InnerWrapper
            className="flexSpaceCenter"
            style={{ padding: "30px 0" }}
          >
            <StyledLink
              className="flexCenter animate pointer"
              to="home"
              smooth={true}
              offset={-80}
            >
              {/* <LogoImg /> */}
              {/*<h1
                className="font15 extraBold whiteColor"
                style={{ marginLeft: "15px" }}
              >
                reMIND
              </h1>*/}
              <ServiceLogoWhite width={80} height={24} />
            </StyledLink>
            <StyleP className="whiteColor font13">
              © {getCurrentYear()} - <span className="font13">reMIND</span> All
              Right Reserved
            </StyleP>

            <StyledLink
              className="whiteColor animate pointer font13"
              to="home"
              smooth={true}
              offset={-80}
            >
              Back to top
            </StyledLink>
          </InnerWrapper>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
`;
const InnerWrapper = styled.div`
  @media (max-width: 550px) {
    flex-direction: column;
  }
`;
const StyleP = styled.p`
  @media (max-width: 550px) {
    margin: 20px 0;
  }
`;

const StyledLink = styled(Link)`
  color: white;
  font-size: 13px;
  cursor: pointer;
  transition: color 0.3s;

  &:hover {
    color: #2a2a2a;
  }
`;